import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "documents-grid" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { class: "select-all" }
const _hoisted_4 = {
  key: 0,
  class: "table-selection-text"
}
const _hoisted_5 = {
  key: 0,
  class: "select-options"
}
const _hoisted_6 = { class: "documents grid" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "row controls between" }
const _hoisted_9 = { class: "row file-icon" }
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = { class: "row file-name" }
const _hoisted_12 = { class: "row analytics between" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "row analytics between" }
const _hoisted_15 = {
  key: 0,
  class: "value"
}
const _hoisted_16 = {
  key: 1,
  class: "value"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "add-icon" }
const _hoisted_19 = { class: "add-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Boolean = _resolveComponent("Boolean")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Checkbox, {
          active: _ctx.selectAll,
          selectAll: "",
          onToggleAll: _ctx.handleToggleAll
        }, null, 8, ["active", "onToggleAll"]),
        (_ctx.selectedDocuments.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.selectedDocuments.length - _ctx.deselectedDocuments.length) + " ", 1),
              _createVNode(_component_TranslatedText, { path: "documents.selected" })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.selectedDocuments.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Chip, {
              chip: _ctx.actionsChip,
              size: "sm",
              customClass: "chip-full-width",
              onToggleChip: _ctx.toggleActionsChip,
              onClickMenuItem: _ctx.clickActionItem
            }, null, 8, ["chip", "onToggleChip", "onClickMenuItem"]),
            _createVNode(_component_Button, {
              text: "Clear all",
              size: "sm",
              outline: ""
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document) => {
        return (_openBlock(), _createElementBlock("div", {
          key: document.id,
          class: "col sm:col-6 xl:col-3"
        }, [
          (_ctx.preparedDocs[`document-${document.documentReference}`])
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "document",
                onClick: ($event: any) => (
            _ctx.viewDocument(
              document.documentReference,
              document.textItems,
              document.id
            )
          )
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Checkbox, {
                    active: 
                _ctx.selectedDocuments.includes(
                  _ctx.getDocumentContentId(document.documentReference)
                ) &&
                !_ctx.deselectedDocuments.includes(
                  _ctx.getDocumentContentId(document.documentReference)
                )
              ,
                    onToggleCheckbox: ($event: any) => (
                _ctx.handleToggleCheckbox(document.documentReference)
              )
                  }, null, 8, ["active", "onToggleCheckbox"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "copy",
                      size: "3x"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.findTextItem("title", document.textItems)), 1),
                _createElementVNode("div", _hoisted_12, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "key" }, "Viewed", -1)),
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_Boolean, {
                      value: 
                  !!(
                    document.actionProgressObjects[0].viewed ||
                    document.actionProgressObjects[0].completed
                  )
                
                    }, null, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "key" }, "Signed", -1)),
                  (_ctx.getSignOffStatus(document.documentReference))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _createVNode(_component_Boolean, {
                          value: 
                  !!(
                    document.actionProgressObjects[0].viewed &&
                    document.actionProgressObjects[0].completed
                  )
                
                        }, null, 8, ["value"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, "N/A"))
                ])
              ], 8, _hoisted_7))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "not-uploaded document",
                onClick: ($event: any) => (
            _ctx.viewDocument(
              document.documentReference,
              document.textItems,
              document.id
            )
          )
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "icon",
                    size: "3x",
                    icon: "plus"
                  })
                ]),
                _createElementVNode("span", _hoisted_19, " Click to add " + _toDisplayString(_ctx.findTextItem("title", document.textItems)) + " here ", 1)
              ], 8, _hoisted_17))
        ]))
      }), 128))
    ])
  ]))
}